function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';
const RecommendationTooth = props => {
  const theme = useTheme();
  const colors = theme.palette;
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 12 10",
    sx: {
      width: 12,
      height: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99998 7.7799L1.21998 4.9999L0.273315 5.9399L3.99998 9.66656L12 1.66656L11.06 0.726562L3.99998 7.7799Z",
    fill: colors.common.white
  }));
};
export default RecommendationTooth;